export const getDangerZone = (fetch: Client.HttpClient) => () =>
  fetch.get<Sentinel.DangerZones.GetDangerZoneResponse>("/api/dangerzone");

export const updateDangerZone =
  (fetch: Client.HttpClient) => (data: Sentinel.DangerZones.UpdateRequest) =>
    fetch.put("/api/dangerzone", { body: data });
